export default "__VITE_ASSET__BakUJJdb__"